import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana97Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1462_13740)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M606.84 542.319L583.22 495.08L526.897 525.967L554.15 582.29C565.657 576.84 590.851 564.848 599.572 560.488C608.293 556.127 608.051 546.558 606.84 542.319Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M497.82 609.545L554.143 582.292L528.707 531.419L459.666 565.94C465.116 578.658 472.02 595.373 477.834 604.094C483.648 612.815 492.975 610.756 497.82 609.545Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M436.054 515.068L459.674 565.941L528.715 531.42L505.096 482.364L436.054 515.068Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M555.966 435.128L583.22 495.085L526.896 525.972L497.826 464.198L555.966 435.128Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M526.894 375.169L555.964 435.126L497.824 464.196L470.57 404.239L526.894 375.169Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M499.639 317.025L526.892 375.166L470.569 404.236L443.315 346.096L499.639 317.025Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M412.429 466.012L436.049 515.068L505.09 482.364L483.288 433.309L412.429 466.012Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M390.626 416.955L412.429 466.011L483.288 433.307L461.485 384.251L390.626 416.955Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M367.008 369.718L390.628 416.957L461.486 384.253L437.867 335.197L367.008 369.718Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M477.837 267.973L499.64 317.029L443.316 346.099L412.429 286.142C417.88 283.114 432.778 274.878 448.767 266.156C464.755 257.435 474.809 263.734 477.837 267.973Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M367.011 369.716L437.869 335.195L412.431 286.14C396.079 293.407 361.56 309.032 354.292 313.393C347.025 317.753 347.631 328.534 348.842 333.379L367.011 369.716Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13740" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13740" transform="matrix(0.00249216 0 0 0.00330393 -5.06883 -2.82356)"/>
    </pattern>
    <image id="image0_1462_13740" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};